export class Course {
    public object = {
    active: true,
    name: '',
    description: '',
    learningEndDuration:'',
    trainingProvider: "Sonacademy",
    durationInHours:'',
    sessionsPerWeek:'',


    associateIds:[],
    startDate:'',
    endDate:'',
    domain:'',
    


    lastEditedBy: {
        name:'',
        id:'',
        time: new Date()
    },
    lastValidatedBy: {
        name:'',
        id:'',
        time: new Date(),
    },
    lastArchivedBy: {
        name:'',
        id:'',
        time: new Date(),
    },
    validated: Number,
    created: new Date(),
    };
}
